<template>
  <div :class="{iframe_container_resume: this.claseAsignado, iframe_container: !this.claseAsignado}">
    <iframe
      :src="src"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    isAsignado: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return{
      claseAsignado: false
    }
  },
  mounted() {
    window.addEventListener('message', this.frameSaldosListener);
    if(this.isAsignado != null && this.isAsignado != undefined){
      this.claseAsignado = this.isAsignado;
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.frameSaldosListener);
  },
  methods: {
    frameSaldosListener(e){
      if(e.data.informacionData.mensaje != null && e.data.informacionData.mensaje != undefined) {
        e.stopPropagation();
        if (e.data.messageType === "informacion") {
          window.removeEventListener("message", this.frameSaldosListener);
        } 
      }
    }
  }
};
</script>

<style scoped>
.iframe_container {
  width: 100%;
  height: 600px; /* Se agrega unidad px */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Para evitar que se muestre contenido fuera del frame */
}

.iframe_container_resume {
  width: 100%;
  height: 380px; /* Se agrega unidad px */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Para evitar que se muestre contenido fuera del frame */
}

iframe {
  width: 100%;
  height: 100%; /* Ajusta la altura al contenedor */
  border: none;
}
</style>
